//CATÉGORIE D'ÉVÈNEMENT CHOISIE (accueil ou page Évènements) : affichée ensuite par la page de détail
//Les constantes d'action sont définies ici, et non dans les composants, pour éviter les imports circulaires avec le store.

export const EVENT_CATEGORY_SELECTED = "EVENT_CATEGORY_SELECTED";

const initialState = "";

export default function eventCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case EVENT_CATEGORY_SELECTED:
      return action.payload;
    default:
      return state;
  }
};
